<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Manual OTA </span>
    </div>
    <div class="button-group">
      <app-ota-info></app-ota-info>
    </div>
  </div>

  <form [formGroup]="deviceOTAForm" novalidate>
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Search Device</h6>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <div class="component-body">
        <div class="form-section">
          <div class="form-group">
            <label for="imei" class="form-label">IMEI</label>
            <mat-form-field appearance="outline">
              <mat-label>IMEI</mat-label>
              <input
                matInput
                formControlName="imei"
                placeholder="IMEI"
                required
              />
              @if (
                deviceOTAForm.controls['imei'].touched &&
                deviceOTAForm.controls['imei'].errors?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    deviceOTAForm.controls['imei'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
              @if (
                deviceOTAForm.controls['imei'].touched &&
                deviceOTAForm.controls['imei'].errors?.exactLengthValidator
              ) {
                <mat-error>
                  {{
                    deviceOTAForm.controls['imei'].errors?.exactLengthValidator
                  }}
                </mat-error>
              }
              @if (
                deviceOTAForm.controls['imei'].touched &&
                deviceOTAForm.controls['imei'].errors?.numericValidator
              ) {
                <mat-error>
                  {{ deviceOTAForm.controls['imei'].errors?.numericValidator }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="component-separator"></div>

      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          <button
            type="button"
            class="submit-button"
            [disabled]="deviceOTAForm.get('imei')?.invalid"
            (click)="onSearch(deviceOTAForm?.get('imei')?.value)"
          >
            Search <mat-icon class="btn-icon">edit</mat-icon>
          </button>
          @if (isSearched && createManualOta) {
            <button
              type="button"
              class="submit-button"
              [disabled]="deviceOTAForm.get('imei')?.invalid"
              (click)="setManualOta()"
            >
              Manual OTA <mat-icon class="btn-icon">add</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>

    @if (manualOtaToggle) {
      <!-- OTA Command List -->
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">OTA Command List</h6>
          <div class="component-actions">
            <app-common-component-dropdown-search
              [items]="otaOverviewFilter"
              [initialValue]="filterForm?.get('filterSelected')?.value"
              [placeHolder]="'Select OTA Type'"
              (itemSelected)="filterSelected($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              (searchSubmit)="onSearchOtaCommandList($event)"
            ></app-common-search>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          @if (commandArray.length > 0) {
            <div class="ota-form-section">
              @for (item of commandArray; track item) {
                <div class="border">
                  <mat-checkbox
                    class="full-width-checkbox"
                    (change)="addToCheckedArray($event, item)"
                    [checked]="checkChecked(item)"
                    [id]="'flexCheckDefault' + item.name"
                  >
                    {{ item.name }}
                  </mat-checkbox>
                </div>
              }
            </div>
          } @else {
            <table>
              <tr>
                <td>
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </table>
          }
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button
              class="edit-button"
              type="button"
              (click)="toggleSelectAll()"
            >
              {{ allSelected ? 'Deselect All' : 'Select All' }}
              <mat-icon class="btn-icon">{{
                allSelected ? 'check_box_outline_blank' : 'check_box'
              }}</mat-icon>
            </button>
            <button
              type="button"
              (click)="SubmitCommandArray()"
              class="submit-button"
              [disabled]="checkedArr.length === 0"
            >
              Set Batch<mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      </div>

      @if (config && checkedArr.length > 0) {
        <div class="component-container">
          <div class="component-header">
            <h6 class="component-title">Set Configuration Value</h6>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>

          <!-- Component Body Section -->
          <div class="component-body">
            <form [formGroup]="CommandForm">
              <table>
                <tr>
                  <th>OTA Command Name</th>
                  <th>OTA Command to be Triggered</th>
                  <th>Example</th>
                  <th>Input Value</th>
                  <th>Action</th>
                </tr>
                <tbody>
                  @for (
                    item of otaListSelected
                      | paginate
                        : {
                            id: 'para_pagination',
                            itemsPerPage: size,
                            currentPage: page,
                            totalItems: totalLength,
                          };
                    track item
                  ) {
                    <tr>
                      <td>
                        {{ item.name }}
                      </td>
                      <td>
                        {{ item.otaCommand }}
                      </td>
                      <td>
                        {{ item.example }}
                      </td>
                      <td>
                        <div class="form-group">
                          <mat-form-field appearance="outline">
                            <mat-label>Input Value</mat-label>
                            <input
                              matInput
                              type="text"
                              placeholder="Please Enter Input Value"
                              aria-label="OTA Command name"
                              formControlName="{{ item.otaCommand }}"
                            />
                            @if (
                              CommandForm.controls[item.otaCommand]?.touched &&
                              CommandForm.controls[item.otaCommand]?.errors
                                ?.requiredAndNoEmptySpaces
                            ) {
                              <mat-error>
                                {{
                                  CommandForm.controls[item.otaCommand].errors
                                    ?.requiredAndNoEmptySpaces
                                }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </td>
                      <td>
                        <div class="action-buttons">
                          <button
                            class="primary-button delete-button"
                            type="button"
                            (click)="deleteCommand(item.id)"
                          >
                            <mat-icon class="btn-icon"> delete </mat-icon>
                          </button>
                          <button
                            class="primary-button export-button"
                            type="button"
                            (click)="clearCommand(item.otaCommand)"
                          >
                            <mat-icon class="btn-icon"> backspace </mat-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </form>
          </div>
          <div class="component-separator"></div>
          <div class="component-footer">
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="size"
              [currentPage]="page"
              (pageChange)="changePage($event)"
              (sizeChange)="changeSize($event)"
            >
            </app-common-component-pagination>
          </div>

          <div class="component-separator"></div>

          <div class="component-footer">
            <div class="button-group">
              <button
                (click)="submit()"
                type="button"
                class="submit-button"
                [disabled]="CommandForm?.invalid"
              >
                Submit Batch<mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
    }
  </form>

  @if (isSearched) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Device OTA History List</h6>
        <div class="component-actions">
          <button
            type="button"
            class="primary-button"
            (click)="exportToExcel()"
            [disabled]="deviceList.length === 0"
          >
            Download<mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Batch Id</th>
              <th>Created By</th>
              <th>IMEI</th>
              <th>OTA Triggered</th>
              <th>OTA Response</th>
              <th>Remark</th>
              <th>Updated At</th>
              @if (deleteOta || deleteManualOta) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (deviceList.length > 0) {
            <tbody>
              @for (
                device of deviceList
                  | paginate
                    : {
                        id: 'paginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track device;
                let i = $index
              ) {
                @if (device.otaCommands?.length > 0) {
                  @for (
                    command of device.otaCommands;
                    track command;
                    let j = $index
                  ) {
                    <tr
                      [ngClass]="{
                        'red-row': device.isAborted,
                        'green-row':
                          device.deviceStatus?.trim()?.toLowerCase() ===
                            'completed' && !device.isAborted,
                      }"
                      [matTooltip]="
                        device.isAborted ? device.abortReason || 'Aborted' : ''
                      "
                    >
                      <!-- BATCH ID -->
                      @if (j === 0) {
                        <td [attr.rowspan]="device.otaCommands.length">
                          {{ device.batchId ? device.batchId : '--' }}
                        </td>

                        <!-- CREATED BY -->
                        <td [attr.rowspan]="device.otaCommands.length">
                          {{
                            device.userData?.[0]
                              ? device.userData[0].firstName +
                                ' ' +
                                device.userData[0].lastName
                              : '--'
                          }}
                          <br />

                          {{
                            device.createdAt
                              ? (device.createdAt
                                | date: 'dd MMM yyyy | hh:mm:ss a')
                              : '--'
                          }}
                        </td>

                        <!-- IMEI -->
                        <td [attr.rowspan]="device.otaCommands.length">
                          {{ device.imei || '--' }}
                        </td>
                      }

                      <!-- OTA TRIGGERED -->
                      <td>
                        {{ command.command || '--' }}
                      </td>

                      <!-- OTA RESPONSE -->
                      <td>
                        {{ command.response || '--' }}
                      </td>

                      <!-- REMARK -->
                      <td>
                        {{ command.status || '--' }}
                      </td>

                      <!-- UPDATED AT -->
                      <td>
                        {{
                          command.updatedAt
                            ? (command.updatedAt
                              | date: 'dd MMM yyyy | hh:mm:ss a')
                            : '--'
                        }}
                      </td>

                      <!-- ACTION -->
                      @if (j === 0 && (deleteOta || deleteManualOta)) {
                        <td [attr.rowspan]="device.otaCommands.length">
                          <div class="action-buttons">
                            @if (device.batchId) {
                              <button
                                type="button"
                                class="primary-button abort-button"
                                [disabled]="
                                  device.deviceStatus === 'Aborted' ||
                                  device.deviceStatus === 'Completed' ||
                                  !deleteOta
                                "
                                (click)="deleteOtaBatchDetails(device._id)"
                              >
                                <mat-icon class="btn-icon">block</mat-icon>
                              </button>
                            }

                            @if (!device.batchId) {
                              <button
                                type="button"
                                class="primary-button abort-button"
                                [disabled]="
                                  device.deviceStatus === 'Aborted' ||
                                  device.deviceStatus === 'Completed' ||
                                  !deleteManualOta
                                "
                                (click)="deleteOtaBatchDetails(device._id)"
                              >
                                <mat-icon class="btn-icon">block</mat-icon>
                              </button>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                } @else {
                  <tr>
                    <td>--</td>
                    <td>--</td>
                    <td>
                      {{ device.imei || '--' }}
                    </td>
                    <td>--</td>
                    <td>--</td>
                    <td>
                      {{ device.deviceStatus || 'Pending' }}
                    </td>
                    <td>
                      {{
                        device.updatedAt
                          ? (device.updatedAt
                            | date: 'dd MMM yyyy | hh:mm:ss a')
                          : '--'
                      }}
                    </td>

                    @if (deleteOta || deleteManualOta) {
                      <td>
                        <div class="action-buttons">
                          @if (device.batchId) {
                            <button
                              type="button"
                              class="primary-button abort-button"
                              [disabled]="
                                device.isAborted ||
                                device.deviceStatus === 'Completed' ||
                                !deleteOta
                              "
                              (click)="deleteOtaBatchDetails(device._id)"
                            >
                              <mat-icon class="btn-icon">block</mat-icon>
                            </button>
                          }

                          @if (!device.batchId) {
                            <button
                              type="button"
                              class="primary-button abort-button"
                              [disabled]="
                                device.isAborted ||
                                device.deviceStatus === 'Completed' ||
                                !deleteManualOta
                              "
                              (click)="deleteOtaBatchDetails(device._id)"
                            >
                              <mat-icon class="btn-icon">block</mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (deviceList.length !== 0) {
          <app-common-component-pagination
            [totalItems]="deviceList.length"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
